// themePrimitives.ts
import type { CssVarsThemeOptions } from "@mui/material/styles";

export const colorSchemes: NonNullable<CssVarsThemeOptions["colorSchemes"]> = {
    light: {
        palette: {
        primary: { main: "#7850AA", dark: "#5E3D8A", light: "#C77DFF", contrastText: "#FFFFFF" },
        secondary: { main: "#7850AA" },
        success: { main: "#147D58", dark: "#126648" },
        error: { main: "#B42347", dark: "#8F1D39" },
        background: { default: "#F7F7FB", paper: "#FFFFFF" },
        text: { primary: "#111827", secondary: "#566174" },
        },
    },
    dark: {
        palette: {
        mode: "dark",
        primary: { main: "#DDB8FA", dark: "#C395E5", light: "#EBD7FC", contrastText: "#281B38" },
        secondary: { main: "#C9BFD6" },
        success: { main: "#6EE7B7", dark: "#34D399" },
        error: { main: "#FDA4AF", dark: "#FB7185" },
        background: { default: "#1C1526", paper: "#281F35" },
        text: { primary: "#F8F5FC", secondary: "#C9BFD6" },
        },
    },
};

export const typography: NonNullable<CssVarsThemeOptions["typography"]> = {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: { fontSize: "2rem", fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.25 },
    h3: { fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.3 },
    h6: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600, minHeight: 44 },
    body1: { fontSize: "1rem", lineHeight: 1.5 },
    body2: { lineHeight: 1.45 },
};

export const shadows = undefined as any;
export const shape      = { borderRadius: 12 };
